import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { justForSideEffectWithPayload, justForSideEffect } from 'src/infrastructure/saga.helpers'
import {
  FractionState,
  GetScaleWeightPayload,
  ScaleWeight,
  PrintFractionTagPayload,
  PauseFractioningPayload,
} from './FractionTypes'

export const initialState: FractionState = {
  isLocalRaspberryConnected: false,
  isRemotePrinterConnected: false,
  scaleWeight: {},
  fractionTag: undefined,
}

const getScaleWeight = justForSideEffectWithPayload<GetScaleWeightPayload>()
const checkLocalRaspberryStatus = justForSideEffect()
const checkRemotePrinterStatus = justForSideEffect()
const getActiveFractionTagData = justForSideEffect()
const printFractionTag = justForSideEffectWithPayload<PrintFractionTagPayload>()
const pauseFractioning = justForSideEffectWithPayload<PauseFractioningPayload>()

const setLocalRaspberryConnected = (
  state: FractionState,
  action: PayloadAction<boolean>,
): FractionState => ({
  ...state,
  isLocalRaspberryConnected: action.payload,
})

const setRemotePrinterConnected = (
  state: FractionState,
  action: PayloadAction<boolean>,
): FractionState => ({
  ...state,
  isRemotePrinterConnected: action.payload,
})

const setScaleWeight = (
  state: FractionState,
  action: PayloadAction<ScaleWeight>,
): FractionState => ({
  ...state,
  scaleWeight: {
    ...state.scaleWeight,
    weight: action.payload.weight,
  },
})

const setFractionTag = (
  state: FractionState,
  action: PayloadAction<any>,
): FractionState => ({
  ...state,
  fractionTag: action.payload,
})

const clearField = (
  state: FractionState,
  action: PayloadAction<string>,
): FractionState => {
  const field = action.payload
  return ({
    ...state,
    [field]: initialState[field],
  })
}

const slice = createSlice({
  name: 'fraction',
  initialState,
  reducers: {
    getScaleWeight,
    checkLocalRaspberryStatus,
    checkRemotePrinterStatus,
    getActiveFractionTagData,
    printFractionTag,
    pauseFractioning,
    setLocalRaspberryConnected,
    setRemotePrinterConnected,
    setScaleWeight,
    setFractionTag,
    clearField,
  },
})

export default slice.reducer

export const { actions } = slice
